// Card #3555 (HITS Del Mar, 2026-10-18); #3681 turned the per-class banner into a
// header count badge + class filter, both driven by this one predicate.
// A scribe's class list is only the
// classes assigned to them, so a class with riders and NO scribe at all never
// reaches any tablet: the scribe cannot find the rider and hand-adds one with
// no name. Staff need to hear about it BEFORE that happens (ADR 0004).
//
// This applies to EVERY class. It deliberately reads nothing off a class name,
// a class number or the decimal in sngClassID: no "RO" / "split" / "main
// class" detection anywhere (Jaybill, 2026-10-18).
const hasScribe = (classItem) =>
  Object.values(classItem?.scribeAssignments || {}).some((ids) => Array.isArray(ids) && ids.length > 0);

// Classes that sit in a ring, have at least one ride, and have no scribe
// assigned at any position. `ridesByClassId` is the show's rides grouped by
// class; a class absent from it (rides still loading) is not flagged.
export function classesWithRidersAndNoScribe(classes, ridesByClassId) {
  return (classes || []).filter(
    (c) =>
      c?.ring &&
      c.hidden !== true &&
      (ridesByClassId?.[c.id]?.length ?? 0) > 0 &&
      !hasScribe(c),
  );
}
